import { GroupAttributionMitreSidePanelWebComponent } from './component/GroupAttributionMitreSidePanelWebComponent';

export { GroupAttributionMitreSidePanelWebComponent };
